export default __webpack_public_path__ + "static/media/goodDay-tree.7816a58b.gif";